import { StocktakeItemInfo } from "../../models/models";
import { getEmptyItem } from './Item';
import { getEmptyStocktakeItem } from './StocktakeItem';
import { getEmptyUser } from './User';

export function getEmptyStocktakeItemInfo(): StocktakeItemInfo
{
		return {
			category: null,
			item: getEmptyItem(),
			user: getEmptyUser(),
			stocktake_item: getEmptyStocktakeItem()
		}
}
